const baseUrl = "https://www.tebinja.com/api/v1/premature";

const urls = {
  baseUrl,
  calculator: `${baseUrl}/calculator`,
  singleResult: (id) => `${baseUrl}/${id}`,
  sendOtp: `${baseUrl}/send-otp`,
  verify: `${baseUrl}/verify-otp`,
  remind: `${baseUrl}/reminder`,
};

export default urls;
